module.exports = __webpack_public_path__ + "img/kljs02_banner_img.50755150.png";